export const CHROME_STORE_URL =
  'https://chromewebstore.google.com/detail/Terum%20MVP%20Connector/mknjpinaknkdghfofomfgckpjpmeoial';

export const PROJECT_PALETTE = ['#8570ff', '#a48cff', '#00d4ff', '#00e89d', '#ffb84a', '#ff6b8a'];

export const PERSON_PALETTE = [
  '#44BBFF', '#FFCC00', '#FF77FF', '#44FF88',
  '#FF4444', '#44FFEE', '#FF8844', '#DDDD44',
];
